(function ($) {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the blog-list-block HTML.
	 *
	 * @date    04/05/2024
	 * @since   4.0.0
	 *
	 * @return  void
	 */
	const initializeBlock = function ($block) {
		$block.find('a.page-number').on('click', function (e) {
			e.preventDefault();

			let link = $(this).attr('href');
			$.ajax({
				url: link,
				type: 'GET',
				success: function (data) {
					let posts = $(data).find('#blog-list').html();
					$('#blog-list').html(posts);

					let pagination = $(data).find('#pagination').html();
					$('#pagination').html(pagination);
					$(window).scrollTop($('#blog-list').offset().top);
					initializeBlock($block);
				},
			});
		});
	};

	// Initialize each block on a page load (front end).
	$(document).ready(function () {
		$('.wp-block-acf-blog-list-block').each(function () {
			initializeBlock($(this));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			'render_block_preview/type=blog-list-block',
			function ($block) {
				initializeBlock($($block));
			}
		);
	}
})(jQuery);
